import { useState } from "react";

export const RetryImg = ({ src, ...props }) => {
  const [tries, setTries] = useState(0);
  const url = tries ? `${src}${src.includes("?") ? "&" : "?"}r=${tries}` : src;
  const onError = () => {
    if (tries < 3) setTimeout(() => setTries((t) => t + 1), 700 * (tries + 1));
  };
  return <img src={url} onError={onError} {...props} />;
};
